import React, { useState, useEffect } from 'react';
import useFetchConversations from '../../../../hooks/conversations/useFetchConversations';
import EmployerConversationCard from '../Company/Inbox/EmployerConversationCard/EmployerConversationCard';
import EmployeeConversationCard from './EmployeeConversationCard';
import CompanyConversationCard from './CompanyConversationCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInbox, faComments } from '@fortawesome/pro-solid-svg-icons';
import './inbox.css';
import Loading from '../../Loading/Loading';

const InboxView = ({ userId, userType }) => {
    const [flashMessage, setFlashMessage] = useState('');
    const [conversationType, setConversationType] = useState('applicant');
    const { conversations, error, loading, fetchConversations, clearConversations } = useFetchConversations(userType, conversationType);

    useEffect(() => {
    }, [conversationType, conversations]);

    const displayFlashMessage = (message) => {
        setFlashMessage(message);
        setTimeout(() => {
          setFlashMessage(null);
        }, 3000);   
    };

    const refreshItems = () => {
      fetchConversations()
    }

    // Listen for restaurant context updates to refresh conversations
    useEffect(() => {
        const handleRestaurantContextUpdated = () => {
            clearConversations();
            setTimeout(() => {
                refreshItems();
            }, 100);
        };

        window.addEventListener('restaurantContextUpdated', handleRestaurantContextUpdated);
        
        return () => {
            window.removeEventListener('restaurantContextUpdated', handleRestaurantContextUpdated);
        };
    }, [conversationType, userType, clearConversations]);

    const onConversationDeleted = () => {
      displayFlashMessage('Conversación eliminada')
      refreshItems()
    }

    
    return (
        <>
         {flashMessage && (
            <div className="flash-message">
            <p>{flashMessage}</p>
            </div>
         )}
        
         <div className="inbox-view__container">
            <h1>Tus conversaciones</h1>
            <div className="inbox-view__button-toggle-container">
                <button
                    onClick={() => setConversationType('applicant')}
                    className={conversationType === 'applicant' ? 'active' : ''}
                >
                    Trabajos
                </button>
                <button
                    onClick={() => setConversationType('talent')}
                    className={conversationType === 'talent' ? 'active' : ''}
                >
                    Talentos
                </button>
            </div>


            {loading && <><Loading/></>} 

            {!loading && !error && conversations.length === 0 && (
                <div className="inbox-view__empty-state">
                    <div className="empty-state__icon">
                        <FontAwesomeIcon icon={faInbox} />
                    </div>
                    <h2 className="empty-state__title">No hay mensajes</h2>
                    <p className="empty-state__description">
                        Las conversaciones aparecerán aquí cuando comiences a comunicarte con candidatos o talentos.
                    </p>
                    <div className="empty-state__info">
                        <div className="info-item">
                            <FontAwesomeIcon icon={faComments} />
                            <span>Puedes iniciar conversaciones desde las páginas de candidatos o talentos</span>
                        </div>
                    </div>
                </div>
            )} 

            <div className="inbox-view__cards-container">
                {!loading && !error && conversations.length > 0 && (
                    userType === 'empresas' ? (
                        conversations.map((talent) => (
                            <EmployerConversationCard 
                              key={talent.employee.id} 
                              data={talent} 
                              onConversationDeleted={onConversationDeleted}
                              clearConversations={clearConversations}
                            />
                        ))
                    ) : (
                        conversationType === 'talent' ? (
                            conversations.map((conversation) => (
                                <CompanyConversationCard 
                                  key={conversation.id} 
                                  data={conversation} 
                                  onConversationDeleted={onConversationDeleted}
                                  clearConversations={clearConversations}
                                />
                            ))
                        ) : (
                            conversations.map((conversation) => (
                                <EmployeeConversationCard 
                                  key={conversation.id} 
                                  data={conversation} 
                                  userType={userType} 
                                  onConversationDeleted={onConversationDeleted}
                                  clearConversations={clearConversations}
                                />
                            ))
                        )
                    )
                )}
            </div>
         </div>
        </>
    );
};

export default InboxView;
